import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Modal } from 'flowbite';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { IBase, IBooking, IBookingCreate, IBookingSeat, IFavourites, IServiceAvailability } from 'src/app/models';
import { IBookingDetails } from 'src/app/models/booking/bookingDetails';
import { BookingOrigin, Colors, ExpeditionStatus, ExpeditionType, InputType, NotificationTypes, PhaseStatus, StopMarkerStatus, UserType } from 'src/app/models/enums';
import { BookingsResolver } from 'src/app/resolvers';
import {
  AuthService,
  BookingsService,
  MapUtilsService,
  MarkerRenderService,
  NotificationService,
  RouteService,
  StorageService,
  TownsService,
  UsersService,
  UtilsService,
  WebSocketService
} from 'src/app/services';
import { FavouritesService } from 'src/app/services/favourites/favourites.service';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { initialBookingsState } from 'src/app/store/initialisation/bookings';
import { environment } from 'src/environments/environment';
import { images } from 'src/images';
import { IServiceInfo } from '../../models';
import { canBookOutsideOutlines, favouriteStopId, formatDate, getServiceInfoRoutes, isDoor2DoorService, isTripPlannerService, showsDemandStopIcon } from 'src/app/forms/bookingForms';
import { IFavouritesState } from 'src/app/store/states';
import { initialFavouritesState } from 'src/app/store/initialisation/favourites';
import { SeatProfile } from 'src/app/models/enums/seatProfile';
import { IBulkActionType } from 'src/app/models/enums/bulkActionType';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { APP } from 'src/app/config/app';
import {
  BOOKING_FILTER_KEYS,
  DEFAULT_BOOKING_STATUS,
  IBookingFilters,
  USER_DEFAULT_BOOKING_STATUS,
  deserializeBookingFilters,
  hasAnyFilterKey,
  serializeBookingFilters,
} from 'src/app/filters';
import { ErrorsCode } from 'src/app/models/enums/errorsCode';
import { PlatformLocation } from '@angular/common';

@Component({
    selector: 'app-bookings',
    templateUrl: './bookings.component.html',
    styleUrls: ['./bookings.component.scss'],
    standalone: false
})
export class BookingsComponent implements OnInit, AfterViewInit, OnDestroy {
  public images = images;
  public bookings = initialBookingsState;
  public bookingsScrollbarWidth = 0;
  private bookingsResizeObserver?: ResizeObserver;
  private canBookOutsideOutlines = false;

  public clientsSelected: IBase[] = [];
  public townsSelected: IBase[] = [];
  public servicesSelected: IBase[] = [];
  public routesSelected: IBase[] = [];
  public typesSelected: ExpeditionType[] = [];
  public statusSelected: ExpeditionStatus[] = [];
  public cancelledStatusSelected: boolean;
  public faultsSelected: boolean;
  public searchValue: string;
  public originValue: string;
  public destinationValue: string;

  public maxKmsPerMonth: number;
  public distanceTravelled: number;
  public book: any;

  public TooltipPosition = TooltipPosition;
  public BookingOrigin = BookingOrigin;
  public ExpeditionStatus = ExpeditionStatus;

  public bookingSelected: any;
  public bookingSelectedCopy: any;
  public rebookBooking: boolean;
  public newBooking = false;
  public creatingBooking = false;
  public edit = false;
  public isFullMap = false;
  public bulkBookingsSelected: any[] = [];

  get bulkHasTicketing(): boolean {
    return this.bulkBookingsSelected?.some((b: IBookingDetails) => b.price !== null && b.price !== undefined) ?? false;
  }

  public bookingSelectedForFavourite?: IBooking;
  public bookingSelectedForNotified: IBookingDetails;

  public userType = UserType;

  public map: google.maps.Map;
  private mapReady?: Promise<void>;
  private mapClickListener?: google.maps.MapsEventListener;
  // Left padding leaves room for the booking modal that overlays the map.
  private readonly mapFitPadding = { top: 20, bottom: 150, left: 300, right: 0 };
  private markers: any[] = [];
  public serviceInfos: IServiceInfo[] = [];

  public newBookingObject: IBookingCreate = {} as IBookingCreate;

  public maxReservationTimeModal: Modal;
  public exceedingKmLimitModal: Modal;
  public blockedUserModal: Modal;
  public exceedingKmLimitShowed = false;
  public maxReservationTimeShowed = false;
  public blockedUserShowed = false;
  public deleteBookingModal: Modal;
  public deleteBookingShowed = false;
  public viewFavourites: Modal;
  public viewFavouritesShowed: boolean = false;
  public viewFavouritesSelected: string;
  public favourites: IFavouritesState = initialFavouritesState;
  public favouriteUserId: number;
  public loadingAction = false;
  public loadingPercentage: number = 0;
  public phaseStatus: PhaseStatus = PhaseStatus.IN_PROGRESS;
  public createFavouriteModal: Modal;
  public createFavouriteShowed = false;
  public notifiedBookingModal: Modal;
  public notifiedBookingShowed = false;
  public ticketingStatusModal: Modal;
  public ticketingStatusShowed = false;
  public changeSeats: Modal;
  public changeSeatsShowed = false;
  public bookingCopy: any;
  public bulkDeleteModal: Modal;
  public bulkDeleteShowed = false;
  public reassignAvailabilityModal: Modal;
  public reassignAvailabilityShowed = false;

  public reason: string;
  public penaltyEndDate: Date;
  public penaltyReason: string;

  public creatingFavourite = false;
  public bookingFromFavourite = false;
  public bookingFromFavouriteUserId: number;

  public bookingFromUsers = false;

  public interval: any;
  public searching: boolean = false;

  public closeExceedingKmHandler = false;
  public availabilitiesToBook: any[] = [];

  public bulkAction = '';
  public allBookingsSelected = false;
  public bulkText = 'bookings.actions.deleteBooking.bulkText';
  public routesElement: any = null;
  public availabilitiesElement: any = null;
  public loadingAvailabilities = false;

  public stopToSelect: any;

  public seatsModalEditable = true;
  public userIdFromRoute: number | null = null;

  private queryParamsSub?: Subscription;
  private routeParamsSub?: Subscription;
  private dataSub?: Subscription;

  constructor(
    renderer: Renderer2,
    public literalService: LiteralService,
    private bookingsResolver: BookingsResolver,
    private bookingsService: BookingsService,
    private favouritesService: FavouritesService,
    private activatedRoute: ActivatedRoute,
    public utilsService: UtilsService,
    public mapUtilsService: MapUtilsService,
    private markerRenderService: MarkerRenderService,
    private notificationService: NotificationService,
    private userService: UsersService,
    public router: Router,
    public appComponent: AppComponent,
    public townsService: TownsService,
    private changeDetectorRef: ChangeDetectorRef,
    public storageService: StorageService,
    public routeService: RouteService,
    public serviceInfoService: ServiceInfoService,
    public location: PlatformLocation,
    private authService: AuthService,
    private webSocketService: WebSocketService
  ) {
    renderer.listen('window', 'click', (e: Event) => {
      if (!this.utilsService.isTextSelected() && document.body.contains(e.target as Node)) {
        const modal = document.getElementById('bookingDetailsContainer')!;
        const componentOpen = document.getElementById('bookingsContainer')!;
        const modals: Node[] = [];
        modals.push(document.getElementById('maxReservationTime') as Node);
        modals.push(document.getElementById('exceedingKmLimit') as Node);
        modals.push(document.getElementById('deleteBookingFromBookings') as Node);
        modals.push(document.getElementById('createFavourite') as Node);
        modals.push(document.getElementById('viewFavourites') as Node);
        modals.push(document.getElementById('ticketingStatus') as Node);
        modals.push(document.getElementById('exceedingKmLimit') as Node);
        modals.push(document.getElementById('changeKms') as Node);
        modals.push(document.getElementById('changeAvailability') as Node);
        modals.push(document.getElementById('changeOriginDestination') as Node);
        modals.push(document.getElementById('changeSeats') as Node);
        modals.push(document.getElementById('changeSeats-detail') as Node);
        modals.push(document.getElementById('createFavouriteFromDetail') as Node);
        modals.push(document.getElementById('setFault') as Node);
        modals.push(document.getElementById('exceedingKmLimitEdit') as Node);
        let close = utilsService.closeCustomModalsWithModals(e, modal, modals, componentOpen);

        const path = e.composedPath?.() || [];
        if (path.some(el => (el as HTMLElement).classList?.contains('cdk-overlay-container'))) {
          close = false;
        }
        if (close && this.bulkAction === '') {
          this.bookingSelected = undefined;
          if (this.activatedRoute.snapshot.paramMap.get('id')) {
            this.goToBookings();
          }
        }
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.literalService.setTitle('sidebar.bookings', ' - NEMI Backoffice');
    this.storageService.getRole().then((role) => {
      this.canBookOutsideOutlines = canBookOutsideOutlines(role);
    });

    this.routeParamsSub = this.activatedRoute.paramMap.subscribe((params) => {
      const pathUserId = params.get('userId');
      this.userIdFromRoute = pathUserId ? Number(pathUserId) : null;

      const bookingId = params.get('id');
      if (bookingId) {
        const cancelled = this.activatedRoute.snapshot.queryParamMap.get('cancelled') === 'true';
        this.showBookingData(Number(bookingId), cancelled);
      } else {
        if (this.bookingSelected) this.bookingSelected = undefined;
        if (this.isFullMap && !this.newBooking) this.isFullMap = false;
      }
    });

    // Hydration from storage happens in bookingsHydrationGuard before the resolver
    // fires, so there's exactly one API call per sidebar entry.
    this.queryParamsSub = this.activatedRoute.queryParamMap.subscribe((params) => {
      this.applyQueryParamsToState(params);
    });
  }

  private applyQueryParamsToState(params: ParamMap): void {
    // "From favourite" / "from users" flags (query-param userId, distinct from path-param userId)
    const qUserId = params.get('userId');
    if (qUserId) {
      if (params.get('favouriteId') || params.get('recurrentId') || history.state?.fromFavourite) {
        this.bookingFromFavourite = true;
        this.bookingFromFavouriteUserId = Number(qUserId);
      } else {
        this.bookingFromUsers = true;
      }
    }

    const defaultStatus = this.userIdFromRoute ? USER_DEFAULT_BOOKING_STATUS : DEFAULT_BOOKING_STATUS;
    const filters: IBookingFilters = hasAnyFilterKey(params, BOOKING_FILTER_KEYS)
      ? deserializeBookingFilters(params)
      : {
          selectedClients: [],
          selectedTowns: [],
          selectedServices: [],
          selectedRoutes: [],
          selectedTypes: [],
          selectedStatus: defaultStatus,
          cancelled: false,
          faults: false,
          origin: '',
          destination: '',
        };
    this.clientsSelected = filters.selectedClients;
    this.townsSelected = filters.selectedTowns;
    this.servicesSelected = filters.selectedServices;
    this.routesSelected = filters.selectedRoutes;
    this.typesSelected = filters.selectedTypes;
    this.statusSelected = filters.selectedStatus;
    this.cancelledStatusSelected = filters.cancelled;
    this.faultsSelected = filters.faults;
    this.originValue = filters.origin;
    this.destinationValue = filters.destination;

    const pageParam = params.get('page');
    if (pageParam) {
      const page = Number(pageParam);
      if (!isNaN(page) && page > 0) this.bookings.pagination.actualPage = page;
    } else {
      this.bookings.pagination.actualPage = 1;
    }

    const sizeParam = params.get('size');
    if (sizeParam) {
      const size = Number(sizeParam);
      if (!isNaN(size) && size > 0) this.bookings.pagination.size = size;
    }

    this.searchValue = params.get('search') ?? '';
  }


  updateBookingsScrollbar(): void {
    const container = document.getElementById('bookingsContainer');
    const width = container ? container.offsetWidth - container.clientWidth : 0;
    if (width !== this.bookingsScrollbarWidth) {
      this.bookingsScrollbarWidth = width;
      this.changeDetectorRef.detectChanges();
    }
  }

  private observeBookingsScrollbar(): void {
    const container = document.getElementById('bookingsContainer');
    if (!container) return;
    this.bookingsResizeObserver?.disconnect();
    this.bookingsResizeObserver = new ResizeObserver(() => this.updateBookingsScrollbar());
    this.bookingsResizeObserver.observe(container);
  }

  ngAfterViewInit(): void {
    this.initBookingsInterval();
    this.observeBookingsScrollbar();
    this.dataSub = this.activatedRoute.data.subscribe((data) => {
      if (data['new']) {
        if (!this.newBooking) this.addBooking();
      } else if (this.newBooking) {
        this.newBooking = false;
        this.isFullMap = false;
        this.newBookingObject = {} as IBookingCreate;
      }
      this.observeBookingsScrollbar();
    });
  }

  initBookingsInterval() {
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.getBookings();
    }, 300000);
  }

  clearBookingsInterval() {
    clearInterval(this.interval);
    this.interval = null;
  }

  showCreateFavouriteModal(booking: IBooking) {
    this.bookingSelectedForFavourite = booking;
    this.createFavouriteModal = new Modal(document.getElementById('createFavourite'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.createFavouriteShowed = false),
      onShow: () => (this.createFavouriteShowed = true),
    });
    this.createFavouriteModal.toggle();
  }

  async initMap() {
    const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
    
    const center = await this.userService.getLoggedUserTown();
    const hasCenter = Number.isFinite(center?.latitude) && Number.isFinite(center?.longitude);

    this.map = new Map(document.getElementById('map') as HTMLElement, {
      center: {
        lat: hasCenter ? center.latitude : 41.4696546,
        lng: hasCenter ? center.longitude : 2.0596017
      },
      zoom: APP.DEFAULT_MAP_ZOOM,
      disableDefaultUI: true,
      mapId: environment.mapId,
      // mapTypeControl: true,
      // mapTypeControlOptions: {
      //   style: google.maps.MapTypeControlStyle.DROPDOWN_MENU, // HORIZONTAL_BAR o DROPDOWN_MENU
      //   position: google.maps.ControlPosition.TOP_RIGHT,
      //   mapTypeIds: [
      //     google.maps.MapTypeId.ROADMAP,
      //     google.maps.MapTypeId.SATELLITE
      //   ]
      // }
    });
  }
  

  closeModals() {
    if (this.maxReservationTimeShowed) this.maxReservationTimeModal.toggle();
    if (this.exceedingKmLimitShowed) this.exceedingKmLimitModal.toggle();
    if (this.blockedUserShowed) this.blockedUserModal.toggle();
    if (this.deleteBookingShowed) this.deleteBookingModal.toggle();
    if (this.createFavouriteShowed) this.createFavouriteModal.toggle();
    if (this.viewFavouritesShowed) this.viewFavourites.toggle();
    if (this.notifiedBookingShowed) this.notifiedBookingModal.toggle();
    if (this.ticketingStatusShowed) this.ticketingStatusModal.toggle();
    if (this.changeSeatsShowed) this.changeSeats.toggle();
  };

  async getBookings() {
    this.activatedRoute.snapshot.data['bookings'] = this.bookings;
    if (this.allBookingsSelected) this.allBookingsSelected = false;
    if (this.userIdFromRoute) {
      await this.bookingsResolver.getBookingsByUser(
        this.activatedRoute.snapshot,
        this.userIdFromRoute,
        this.clientsSelected,
        this.townsSelected,
        this.typesSelected,
        this.statusSelected,
        this.cancelledStatusSelected,
        this.faultsSelected,
        this.servicesSelected,
        this.routesSelected,
        this.originValue,
        this.destinationValue,
        this.searchValue
      );
    } else {
      await this.bookingsResolver.getBookings(
        this.activatedRoute.snapshot,
        this.clientsSelected,
        this.townsSelected,
        this.typesSelected,
        this.statusSelected,
        this.cancelledStatusSelected,
        this.faultsSelected,
        this.servicesSelected,
        this.routesSelected,
        this.originValue,
        this.destinationValue,
        this.searchValue
      );
    }
    this.updateBookingsScrollbar();
  }

  changePage(event: { isNext: boolean, specificPage?: number }) {
    const current = this.bookings.pagination.actualPage;
    const newPage = event.specificPage ?? (event.isNext ? current + 1 : current - 1);
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: newPage > 1 ? newPage : null },
      queryParamsHandling: 'merge',
    });
  };

  async showBookingData(bookingId: number, cancelled: boolean) {
    if (this.bulkAction !== '') {
      this.onSelectionChange(bookingId);
      return;
    }
    await this.openBookingDetails(bookingId, cancelled);
  }

  async onCheckboxColumnClick(bookingId: number) {
    this.onSelectionChange(bookingId);
  }

  private async openBookingDetails(bookingId: number, cancelled: boolean) {
    const currentId = this.activatedRoute.snapshot.paramMap.get('id');
    if (currentId !== String(bookingId)) {
      this.router.navigate([...this.bookingsListPath(), bookingId], {
        queryParams: { cancelled: cancelled ? 'true' : null },
        queryParamsHandling: 'merge',
      });
      return;
    }
    try {
      this.bookingSelected = (await this.bookingsService.getBooking(
        bookingId,
        this.cancelledStatusSelected || cancelled
      )) as IBookingDetails;
    } catch {
      this.router.navigate(this.bookingsListPath());
    }
  }

  private bookingsListPath(): string[] {
    return this.userIdFromRoute ? ['/bookings/users', String(this.userIdFromRoute)] : ['/bookings'];
  }

  async getRelatedBookings(booking: IBookingDetails) {
    let relatedBookings: any[] = [];
    await Promise.all(
      booking.relatedBookings.map(async (bookingId: number) => {
        if (booking?.id !== bookingId) {
          await this.bookingsService.getBooking(bookingId).then((bookingDetail: any) => {
            relatedBookings.push(bookingDetail);
          });
        }
      })
    )
    return relatedBookings;
  }

  private async ensureRelatedBookingsLoaded() {
    if (!this.bookingSelected) return;
    if (this.bookingSelected.relatedBookingsInfo !== undefined) return;
    if (!this.bookingSelected.relatedBookings?.length) {
      this.bookingSelected = { ...this.bookingSelected, relatedBookingsInfo: [] };
      return;
    }
    const relatedBookingsInfo = await this.getRelatedBookings(this.bookingSelected);
    this.bookingSelected = { ...this.bookingSelected, relatedBookingsInfo };
  }

  async openDeleteBookingModal() {
    this.deleteBookingModal = new Modal(document.getElementById('deleteBookingFromBookings'), {
      placement: 'center',
      closable: false,
      onHide: () => {
        this.deleteBookingShowed = false;
        this.reason = '';
      },
      onShow: () => (this.deleteBookingShowed = true),
    });
    await this.ensureRelatedBookingsLoaded();
    this.deleteBookingModal.toggle();
  }

  async openTicketingStatusModal() {
    this.ticketingStatusModal = new Modal(document.getElementById('ticketingStatus'), {
      closable: false,
      onHide: () => {
        this.ticketingStatusShowed = false;
        this.bookingSelected = this.bookingSelectedCopy;
      },
      onShow: () => {
        this.ticketingStatusShowed = true;
        this.bookingSelectedCopy = { ...this.bookingSelected };
      },
    });
    await this.ensureRelatedBookingsLoaded();
    this.ticketingStatusModal.toggle();
  }

  async openInFullMap(booking: IBookingDetails) {
    this.isFullMap = true;
    await this.initMap();

    if (this.map && booking) {
      this.map.data.addGeoJson(booking.path);
      this.map.data.setStyle({
        strokeColor: booking.service.color || Colors.TRANSPARENT,
        strokeWeight: 5,
      });
      const bounds = new google.maps.LatLngBounds();
      const markers: any[] = [];
      const markerOrigin = document.getElementById('origin') as HTMLElement;
      markerOrigin.classList.remove('hidden');
      const markerDestination = document.getElementById('destination') as HTMLElement;
      markerDestination.classList.remove('hidden');
      markers.push({
        element: markerOrigin,
        latitude: booking.origin.latitude,
        longitude: booking.origin.longitude,
        name: booking.origin.name
      });
      bounds.union(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(
            booking.origin.latitude!,
            booking.origin.longitude
          ),
        ),
      )
      markers.push({
        element: markerDestination,
        latitude: booking.destination.latitude,
        longitude: booking.destination.longitude,
        name: booking.destination.name
      });
      bounds.union(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(
            booking.destination.latitude!,
            booking.destination.longitude
          ),
        ),
      )
      this.mapUtilsService.addCustomMarkers(this.map, markers);
      setTimeout(() => {
        this.map.fitBounds(bounds);
      }, 500);
    }
  };

  goToNewBooking(): void {
    this.router.navigate(['/bookings/new']);
  }

  goToBookings(): void {
    this.router.navigate(['/bookings']);
  }

  goBackToUsers(): void {
    this.router.navigate(['/users/' + this.bookingFromFavouriteUserId], { state: { fromFavouriteBooking: true } });
  }

  close() {
    if (this.isFullMap && !this.newBooking) {
      this.isFullMap = false;
    } else {
      this.newBookingObject = {} as IBookingCreate;
      if (this.bookingFromFavourite && this.bookingFromFavouriteUserId) {
        this.goBackToUsers();
      } else {
        this.goToBookings();
      }
    }
  };

  async addBooking() {
    this.newBookingObject = {
      door2DoorOriginFreeStops: true,
      door2DoorDestinationFreeStops: true,
    } as IBookingCreate;
    this.isFullMap = true;
    this.newBooking = true;
    // this.bookingSelected = undefined
    this.mapReady = this.initMap();
  };

  async getServiceInfos(event: any) {
    const serviceInfos = event.serviceInfos;
    if (event.user) {
      this.newBookingObject.targetUserId = event.user.id;
      this.newBookingObject.user = event.user
    }
    // const townId = event.townId;
    this.serviceInfos = serviceInfos;
    // On a reload the modal restores its state before Google Maps has finished loading
    await this.mapReady;
    const bounds = new google.maps.LatLngBounds();
    const stops: any[] = [];
    const stopsAvailable: any[] = [];

    const isD2DBooking = isDoor2DoorService(serviceInfos);
    let onOutlineClick = (event: any) => {};
    this.mapClickListener?.remove();
    this.mapClickListener = undefined;
    if (isD2DBooking) {
      const handleFreeStopClick = (event: any) => {
        let bookingObjectCopy = structuredClone(this.newBookingObject);
        if (!bookingObjectCopy.originStop || !bookingObjectCopy.destinationStop) {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          this.mapUtilsService.getNearestRoad(lat, lng).then(async (placeDetails: any) => {
            let newBookingType = 'origin';
            let stopDetails = {
              lat: placeDetails?.location.lat,
              lng: placeDetails?.location.lng,
              name: placeDetails.name
            };
            if (!bookingObjectCopy.originStop && bookingObjectCopy.door2DoorOriginFreeStops) {
              bookingObjectCopy.originStop = {...stopDetails};
              if (bookingObjectCopy.favourite) bookingObjectCopy.favourite.inStop = {name: stopDetails.name, latitude: stopDetails.lat, longitude: stopDetails.lng, code: '', demand: true };
            } else if (!bookingObjectCopy.destinationStop && bookingObjectCopy.door2DoorDestinationFreeStops) {
              bookingObjectCopy.destinationStop = {...stopDetails};
              if (bookingObjectCopy.favourite) bookingObjectCopy.favourite.outStop = {name: stopDetails.name, latitude: stopDetails.lat, longitude: stopDetails.lng, code: '', demand: true };
              bookingObjectCopy.destinationStops = [{
                exitStop: {
                  id: undefined,
                  name: placeDetails.name
                },
                prm: bookingObjectCopy.user.prm,
                profile: SeatProfile.Regular,
                needRequested: false,
                noShow: false
              }]
              newBookingType = 'destination';
            }
            // Outline check lives in the booking modal: only admins may pick outside every outline.
            this.newBookingObject = bookingObjectCopy;
            this.changeDetectorRef.detectChanges();
            this.selectOD({
              newBooking: this.newBookingObject,
              type: newBookingType
            });
          });
        }
      };
      onOutlineClick = handleFreeStopClick;
      this.mapClickListener = this.map.addListener('click', handleFreeStopClick);
    }
    this.mapUtilsService.drawOutlines(this.map, serviceInfos, onOutlineClick, isD2DBooking);

    serviceInfos.forEach((serviceInfo: IServiceInfo) => {
      serviceInfo.stops.forEach((stop: any) => {
        // [DISABLED] restrictedOrigins feature
        // const restrictedOrigin = this.availableOrigins(serviceInfo, stop);
        // if (!restrictedOrigin) {
        const exists = stopsAvailable.some((stopAvailable: any) => stopAvailable.id === stop.id);
        if (!exists) {
          stopsAvailable.push(stop);
        }
        // } else {
        //   const exists = stopsAvailable.some((stopAvailable: any) => stopAvailable.id === stop.id);
        //   if (exists) {
        //     stopsAvailable.push(stop);
        //   }
        // }
      });
    });
    serviceInfos.forEach((serviceInfo: IServiceInfo) => {
      serviceInfo.stops.forEach((stop: any) => {
        const available = stopsAvailable.some((stopAvailable: any) => stopAvailable.id === stop.id);
        const showsDemandIcon = showsDemandStopIcon(stop, serviceInfo);
        let newMarker: HTMLElement;
        if (showsDemandIcon) {
          newMarker = this.markerRenderService.getMarkerElement(available ?StopMarkerStatus.DEMAND_DEFAULT : StopMarkerStatus.DEMAND_DISABLED);
        } else {
          let stopMarker: HTMLElement = document.getElementById('stopMarker') as HTMLElement;
          if (!available) {
            stopMarker = document.getElementById('stopMarkerDisabled') as HTMLElement;
          }
          newMarker = stopMarker.cloneNode(true) as HTMLElement;
          newMarker.classList.remove('invisible');
        }
        newMarker.setAttribute('id', `stop.${serviceInfo.id}.${stop.id}.${available}`);
        const exists = stops.find((s: any) => s.id === stop.id);
        // A stop shared by several services shows one tag per service it takes part in
        if (exists) {
          if (!exists.serviceInfos.some((info: IServiceInfo) => info.id === serviceInfo.id)) {
            exists.serviceInfos.push(serviceInfo);
          }
        } else {
          stops.push({
            id: stop.id,
            name: stop.name,
            available,
            demand: showsDemandIcon,
            marker: newMarker,
            serviceInfos: [serviceInfo],
            lat: stop.location.geometry.coordinates[1],
            lng: stop.location.geometry.coordinates[0],
          });
        }
      });
    });
    stops.forEach((stop: any) => {
      bounds.union(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(
            stop.lat,
            stop.lng,
          ),
        ),
      );
    });
    this.extendBoundsWithOutlines(bounds, serviceInfos);
    if (bounds.isEmpty()) {
      // Nothing to fit yet — fall back to centering on the town itself.
      const townInfo: any = await this.townsService.getTown(event.townId);
      // Town coordinates are nullable in the API
      if (Number.isFinite(townInfo?.latitude) && Number.isFinite(townInfo?.longitude)) {
        bounds.union(
          new google.maps.LatLngBounds(
            new google.maps.LatLng(
              townInfo.latitude,
              townInfo.longitude,
            ),
          ),
        );
      }
    }
    const isOrigin = !this.newBookingObject.originStop;
    const markers = await this.mapUtilsService.addStopsClustersMarkers(this.map, stops, (stop) => {
      this.stopToSelect = {stop, isOrigin};
    });
    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds, this.mapFitPadding);
    }
  }

  // D2D services may define their working area as an outline rather than (or
  // in addition to) a list of stops, so fit to that area too.
  private extendBoundsWithOutlines(bounds: google.maps.LatLngBounds, serviceInfos: IServiceInfo[]) {
    serviceInfos.forEach((serviceInfo: IServiceInfo) => {
      serviceInfo.outlines?.filter((outline) => outline?.geometry?.coordinates?.[0]).forEach((outline) => {
        outline.geometry.coordinates[0].forEach((coord: any) => {
          bounds.union(
            new google.maps.LatLngBounds(
              new google.maps.LatLng(coord[1], coord[0]),
            ),
          );
        });
      });
    });
  }

  // [DISABLED] restrictedOrigins feature
  // availableOrigins(serviceInfo: IServiceInfo, stop: any) {
  //   const restricted = serviceInfo.restrictedOrigins.some((origin: any) => origin === stop.id);
  //   return restricted;
  // };

  selectOD(newBooking: any) {
    // [DISABLED] singleStopReservation feature
    // if (newBooking.isSingleReservation) {
    //   this.markers = [];
    //   this.mapUtilsService.addCustomMarkers(this.map, this.markers, true, (stop: any) => {
    //   this.stopToSelect = {stop, isOrigin: newBooking.type === 'origin'}
    // });
    // }
    if (newBooking.type === 'origin') {
      this.updateMarker('origin', newBooking.newBooking.originStop);
      this.newBookingObject.originStop = newBooking.newBooking.originStop;
    } else if (newBooking.type === 'destination') {
      this.updateMarker('destination', newBooking.newBooking.destinationStop);
      this.newBookingObject.destinationStop = newBooking.newBooking.destinationStop;
      this.newBookingObject.destinationStops = newBooking.newBooking.destinationStops;
    }
    if (isDoor2DoorService(this.serviceInfos)) {
      let outlinesIds: undefined | string[] = undefined;
      if (this.newBookingObject.originStop && !this.canBookOutsideOutlines) {
        outlinesIds = this.mapUtilsService.getOutlineIdsFromCoordinates(this.newBookingObject.originStop.lat, this.newBookingObject.originStop.lng);
      }
      this.mapUtilsService.showOutlines(true, this.map, outlinesIds);
    }
    this.mapUtilsService.addCustomMarkers(this.map, this.markers, false, (stop: any) => {
      this.stopToSelect = {stop, isOrigin: stop.id === 'origin'}
    });
  }

  updateMarker(type: string, newMarker: any) {
    const markerElement = document.getElementById(type) as HTMLElement;
    if (markerElement) markerElement.classList.add('hidden');
    const marker = markerElement.cloneNode(true) as HTMLElement;
    if (marker) marker.classList.remove('hidden');
    
    const index = this.markers.findIndex((marker: any) => marker.id === type);
    if (index > -1) {
      this.markers.splice(index, 1);
    }
    this.markers = this.markers.filter((marker: any) => marker.id !== type);
    if (newMarker) {
      this.markers.push({
        id: type,
        name: newMarker?.name,
        element: marker,
        latitude: newMarker?.lat,
        longitude: newMarker?.lng,
      });
    }
  }

  changeTown(townId: number) {
    const container = document.getElementById('newMarkers');
    const markerOrigin = document.getElementById('origin') as HTMLElement;
    const markerDestination = document.getElementById('destination') as HTMLElement;
    const nodeOrigin = markerOrigin.cloneNode(true) as HTMLElement;
    const nodeDestination = markerDestination.cloneNode(true) as HTMLElement;
    nodeOrigin.classList.add('hidden');
    nodeDestination.classList.add('hidden');
    container?.appendChild(nodeOrigin);
    container?.appendChild(nodeDestination);
    this.mapUtilsService.addCustomMarkers(this.map, undefined, true);
    this.newBookingObject.originStop = undefined;
    this.newBookingObject.destinationStop = undefined;
    this.newBookingObject.destinationStops = [];
    this.newBookingObject.townId = townId;
    this.markers = [];
  };

  public filter(event: { selectedClients: IBase[], selectedTowns: IBase[], selectedServices: IBase[], selectedRoutes: IBase[], selectedTypes: ExpeditionType[], selectedStatus: ExpeditionStatus[], cancelled: boolean, faults: boolean, origin: string, destination: string }) {
    const filters: IBookingFilters = {
      selectedClients: event?.selectedClients ?? [],
      selectedTowns: event?.selectedTowns ?? [],
      selectedServices: event?.selectedServices ?? [],
      selectedRoutes: event?.selectedRoutes ?? [],
      selectedTypes: event?.selectedTypes ?? [],
      selectedStatus: event?.selectedStatus ?? [],
      cancelled: event?.cancelled ?? false,
      faults: event?.faults ?? false,
      origin: event?.origin ?? '',
      destination: event?.destination ?? '',
    };
    // Persist as defaults so the next fresh visit hydrates the URL from storage.
    this.storageService.setBookingsFilters(JSON.stringify(filters));
    this.allBookingsSelected = false;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { ...serializeBookingFilters(filters), page: null },
      queryParamsHandling: 'merge',
    });
  };

  search(event: any) {
    const newSearch = event || null;
    const currentSearch = this.activatedRoute.snapshot.queryParamMap.get('search') || null;
    if (newSearch === currentSearch) {
      this.bookings.isFetchingBookings = true;
      this.bookings.value = [];
      this.getBookings();
      return;
    }
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { search: event || null, page: null },
      queryParamsHandling: 'merge',
    });
  };

  editBooking() {
    this.isFullMap = true;
    this.edit = true;
  };

  closeDetails() {
    this.newBooking = false;
    this.router.navigate(this.bookingsListPath(), {
      queryParams: this.activatedRoute.snapshot.queryParams,
    });
  };

  bookingCreated(multiple: boolean) {
    this.bookingsResolver.invalidateListCache();
    if (this.bookingFromFavourite && this.bookingFromFavouriteUserId) {
      this.router.navigate(['/users/' + this.bookingFromFavouriteUserId], { state: { fromFavouriteBooking: true } });
    } else {
      this.goToBookings();
    }
    this.utilsService.showNotification(images.notifications.check, 'bookings.actions.createBooking', NotificationTypes.SUCCESS, `title${multiple ? 'Multiple' : ''}`, `text${multiple ? 'Multiple' : ''}`);
  }

  async deleteBookingAction(data: any) {
    this.loadingAction = true;
    await this.bookingsService.deleteBooking(this.bookingSelected.id, data.comment, data?.sendNotification, data?.refund, data?.fullRefund, data?.related).then(() => {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.deleteBooking', NotificationTypes.SUCCESS, 'successTitle', 'successText');
      this.deleteBookingModal.toggle();
      this.closeDetails();
      this.getBookings();
    }, () => {
      if (this.bookingSelected.tripStatus === ExpeditionStatus.READY) {
        this.notificationService.image = images.notification.error;
        this.notificationService.title = this.literalService.get(`errorOccurred`, true);
        this.notificationService.message = this.literalService.get(`bookings.actions.deleteBooking.errorText`, true);
        this.notificationService.show(NotificationTypes.DANGER);
      }
    }).finally(() => {
      this.loadingAction = false;
    })
  };

  async markAsAFault() {
    const missed = this.bookingSelected.missed;
    this.bookingSelected = await this.bookingsService.updateMissed(this.bookingSelected.id);
    if (missed) {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.unMarkAsAFault', NotificationTypes.SUCCESS);
    } else {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.markAsAFault', NotificationTypes.SUCCESS);
    }
    this.getBookings();
  };

  async markSeatAsFault(event: { seatId: number, callback: (ok: boolean) => void }) {
    const seat = this.bookingSelected.bookingSeats.find((it: IBookingSeat) => it.id == event.seatId);
    if (seat) {
      const missed = seat.missed;
      try {
       this.bookingSelected = await this.bookingsService.updateMissedSeat(this.bookingSelected.id, event.seatId);
       event.callback(true);
      } catch (err) {
        event.callback(false);
      }
      this.bookingCopy = { 
        ...this.bookingSelected,
        bookingSeats: this.bookingSelected.bookingSeats.map((seat: IBookingSeat) => ({ ...seat })) 
      };
      if (missed) {
        this.utilsService.showNotification(images.notifications.check, 'bookings.actions.unMarkAsAFault', NotificationTypes.SUCCESS);
      } else {
        this.utilsService.showNotification(images.notifications.check, 'bookings.actions.markAsAFault', NotificationTypes.SUCCESS);
      }
      this.getBookings();
    }
    this.changeDetectorRef.detectChanges();
  };

  goToUser(userId: number, userType: UserType): void {
    this.appComponent.setRouteName('users');
    this.router.navigate([`/users${userType === UserType.Driver ? `/${userType.toLowerCase()}` : ''}/${userId}`]);
  }

  goToTrip(event: MouseEvent, tripId: number): void {
    event.preventDefault();
    this.appComponent.setRouteName('trips');
    this.router.navigate(['/trips/' + tripId]);
  }

  showMaxReservationTimeModal() {
    this.maxReservationTimeModal = new Modal(document.getElementById('maxReservationTime'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.maxReservationTimeShowed = false),
      onShow: () => (this.maxReservationTimeShowed = true),
    });
    this.maxReservationTimeModal.toggle();
  };

  showExceedingKmLimitModal(availabilitiesSelected: any) {
    this.availabilitiesToBook = availabilitiesSelected;
    this.maxKmsPerMonth = availabilitiesSelected[0].serviceInfo.routes[0].maxKmsPerMonth || 0;
    this.distanceTravelled = this.newBookingObject.user.distanceTravelled || 0;
    this.exceedingKmLimitModal = new Modal(document.getElementById('exceedingKmLimit'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.exceedingKmLimitShowed = false),
      onShow: () => (this.exceedingKmLimitShowed = true),
    });
    this.exceedingKmLimitModal.toggle();
  };

  showBlockedUserModal(element: any) {
    this.penaltyEndDate = new Date(element.penalty.penaltyEndDate);
    this.penaltyReason = element.penalty.penaltyReason;
    this.newBookingObject = element.booking;
    this.blockedUserModal = new Modal(document.getElementById('blockedUserBooking'), {
      placement: 'center',
      closable: false,
      onHide: () => { this.blockedUserShowed = false; this.reason = ''; },
      onShow: () => (this.blockedUserShowed = true),
    });
    if (!this.blockedUserModal.isVisible()) this.blockedUserModal.toggle();
  };

  back() {
    this.newBookingObject = {} as IBookingCreate;
    this.blockedUserModal.toggle();
  };

  availableDestinations(destinationsStops: any, stop: any) {
    const isSelectable = destinationsStops && destinationsStops.some((dbs: any) => dbs.id === stop.id);
    return isSelectable;
  };

  async selectStop(event: any) {
    const destinationsStops = event.destinationsStops || [];
    const bounds = new google.maps.LatLngBounds();
    let stops: any[] = [];
    this.serviceInfos.forEach((serviceInfo: IServiceInfo) => {
      serviceInfo.stops.forEach((stop: any) => {
        document.getElementById('stop' + serviceInfo.id + stop.id)?.remove();
        const isSelectable = this.availableDestinations(destinationsStops, stop);
        const showsDemandIcon = showsDemandStopIcon(stop, serviceInfo);
        let newMarker: HTMLElement;
        if (showsDemandIcon) {
          newMarker = this.markerRenderService.getMarkerElement(isSelectable ?StopMarkerStatus.DEMAND_DEFAULT : StopMarkerStatus.DEMAND_DISABLED);
        } else {
          let stopMarker: HTMLElement;
          if (isSelectable) {
            stopMarker = document.getElementById('stopMarker') as HTMLElement;
          } else {
            stopMarker = document.getElementById('stopMarkerDisabled') as HTMLElement;
          }
          newMarker = stopMarker.cloneNode(true) as HTMLElement;
          newMarker.classList.remove('invisible');
        }
        newMarker.setAttribute('id', 'stop' + serviceInfo.id + stop.id);
        const exists = stops.find((s: any) => s.id === stop.id);
        if (exists) {
          if (!exists.serviceInfos.some((info: IServiceInfo) => info.id === serviceInfo.id)) {
            exists.serviceInfos.push(serviceInfo);
          }
        } else {
          stops.push({
            id: stop.id,
            name: stop.name,
            available: isSelectable,
            demand: showsDemandIcon,
            marker: newMarker,
            serviceInfos: [serviceInfo],
            lat: stop.location.geometry.coordinates[1],
            lng: stop.location.geometry.coordinates[0],
          });
        }
      });
    });
    stops.forEach((stop: any) => {
      bounds.union(
        new google.maps.LatLngBounds(
          new google.maps.LatLng(
            stop.lat,
            stop.lng,
          ),
        ),
      );
    });
    if (isDoor2DoorService(this.serviceInfos)) {
      this.extendBoundsWithOutlines(bounds, this.serviceInfos);
    }
    if (event.showMarkers) {
      await this.mapUtilsService.addStopsClustersMarkers(this.map, stops, (stop) => {
        const isOrigin = !this.newBookingObject.originStop;
        this.stopToSelect = {stop, isOrigin};
      });
      if (!bounds.isEmpty()) {
        this.map.fitBounds(bounds, this.mapFitPadding);
      }
    }
  };
 
  async createBooking(newBooking: IBookingCreate) {
    this.creatingBooking = true;
    const newBookings = this.makeBookingArray(newBooking, this.availabilitiesToBook);
    await this.bookingsService.multipleBooking(newBookings, isTripPlannerService(this.serviceInfos)).then(() => {
      this.bookingCreated(newBooking.multipleDates);
      this.creatingBooking = false;
    }, (error) => {
      if (error.error_code === ErrorsCode.ENTITY_ALREADY_EXISTS) {
        this.utilsService.showNotification(images.notifications.warning, `${error.error_code}_ERROR.bookings`, NotificationTypes.DANGER);
      }
      this.creatingBooking = false;
    });
  };

  makeBookingArray(newBooking: IBookingCreate, availabilities: any) {
    const newBookings: IBookingCreate[] = [] as IBookingCreate[];
    availabilities.forEach((availability: any) => {
      let booking = {...newBooking};
      booking.availabilityId = availability.availabilityId;
      booking.originStopId = availability.inStop.id!;
      booking.originStop = {
        id: availability.inStop.id,
        name: availability.inStop.name,
        latitude: availability.inStop.latitude,
        longitude: availability.inStop.longitude
      };
      booking.destinationStops.forEach((destination: any) => {
        destination.exitStop = {
          id: availability.outStop.id,
          name: availability.outStop.name,
          latitude: availability.outStop.latitude,
          longitude: availability.outStop.longitude
        };
      });
      booking.destinationId = availability.outStop.id!;
      booking.serviceAvailabilityResponseId = availability.serviceAvailabilityResponseId;
      booking.serviceId = availability.serviceId;
      booking.tripId = availability.expeditionId;
      newBookings.push(booking);
    });
    return newBookings;
  }

  async createFavourite(favouriteName: string) {
    this.creatingFavourite = true;
    await this.favouritesService.createFavouriteFromBooking(favouriteName, this.bookingSelectedForFavourite!).then(() => {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.createFavourite.success', NotificationTypes.SUCCESS);
    }, (error: any) => {
      this.creatingFavourite = false;
    });
    this.createFavouriteModal.toggle();
    this.bookingSelectedForFavourite = undefined;
    this.creatingFavourite = false;
  };

  async bookWithFavourite(favourite: IFavourites) {
    this.viewFavourites.toggle();
    const newBooking = { ...this.newBookingObject };
    this.newBookingObject = {} as IBookingCreate;
    newBooking.targetUserId = this.favouriteUserId;
    newBooking.townId = favourite.town!.id!;
    newBooking.date = moment().format('YYYY-MM-DD');
    newBooking.time = favourite.time!;
    newBooking.favourite = favourite;
    // The favourite's sentinel ids for free stops are only meaningful inside the
    // favourite; the modal re-resolves real stops against the service stop list.
    newBooking.originStop = { ...favourite.inStop, id: favouriteStopId(favourite.inStop) };
    newBooking.destinationStop = { ...favourite.outStop, id: favouriteStopId(favourite.outStop, false) };
    newBooking.originStopId = newBooking.originStop.id;
    if (favourite.favoriteSeats) {
      newBooking.destinationStops = favourite.favoriteSeats.map(seat => ({
        exitStop: {
          id: newBooking.destinationStop.id,
          name: favourite.outStop?.name
        },
        prm: seat.prm,
        name: seat.name,
        profile: seat.profile,
        need: seat.need,
        needRequested: seat.needRequested,
        noShow: false, 
      }));
    }
    this.newBookingObject = newBooking;
    this.bookingFromFavourite = true;
    this.changeDetectorRef.detectChanges();
  };

  async openFavourite(userId: number) {
    this.favourites = initialFavouritesState;
    this.favouriteUserId = userId;
    const favourites = await this.favouritesService.getFavourites(userId, 1, 7);
    this.favourites = favourites;
    this.viewFavourites = new Modal(document.getElementById('viewFavourites'), {
      placement: 'center',
      closable: false,
      onHide: () => (this.viewFavouritesShowed = false),
      onShow: () => (this.viewFavouritesShowed = true),
    });
    this.viewFavourites.toggle();
  };

  async onFavouriteChangePage(event: any) {
    const { isNext, specificPage } = event;
    if (!specificPage) {
      this.favourites.pagination.actualPage = isNext
        ? this.favourites.pagination.actualPage + 1
        : this.favourites.pagination.actualPage - 1;
    } else {
      this.favourites.pagination.actualPage = specificPage;
    }
    this.favourites = await this.favouritesService.getFavourites(this.favouriteUserId, this.favourites.pagination.actualPage, this.favourites.pagination.size);
  }

  async showNotifiedModal(event: Event, bookingId: number, cancelled: boolean = false) {
    if (this.bulkAction === '') {
      this.bookingSelectedForNotified = await this.bookingsService.getBooking(bookingId, cancelled) as IBookingDetails;
      this.notifiedBookingModal = new Modal(document.getElementById('notifiedBooking'), {
        closable: false,
        onHide: () => (this.notifiedBookingShowed = false),
        onShow: () => (this.notifiedBookingShowed = true),
      });
      this.notifiedBookingModal.toggle();
      event.stopPropagation();
    } else {
      this.onSelectionChange(bookingId);
    }
  };

  async modifyNotified(isNotified: boolean) {
    await this.bookingsService.updateNotified(this.bookingSelectedForNotified.id!, isNotified).then((res: any) => {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.notifiedBooking', NotificationTypes.SUCCESS, 'notificationTitle', isNotified ? `notificationNotNotified` : `notificationNotified`);
      const index = this.bookings.value.findIndex((booking: IBooking) => this.bookingSelectedForNotified.id === booking.id);
      this.bookings.value[index].notified = res.isNotified;
    });
    this.notifiedBookingModal.toggle();
  };

  getTooltipText(type: BookingOrigin, notified?: boolean, userPhone?: string) {
    return this.bookingsService.getChannelTooltipText(type, notified, userPhone);
  };

  async deleteFavourite(favouriteId: number) {
    this.viewFavourites.toggle();
    this.favouritesService.deleteFavourite(favouriteId).then(() => {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.viewFavourite.delete', NotificationTypes.SUCCESS, 'successTitle', 'successText');
    }, () => {
      this.utilsService.showNotification(images.notifications.warning, 'bookings.actions.viewFavourite.delete', NotificationTypes.DANGER, 'errorTitle', 'errorText');
    });
  }

  async editFavourite(favourite: IFavourites) {
    // this.appComponent.setRouteName('bookings');
    // this.router.navigate(['/bookings/new'],
    //   {
    //     queryParams:
    //     {
    //       'userId': this.favouriteUserId,
    //       'favouriteId': favourite.id,
    //       'editFavourite': true
    //     },
    //     state: {
    //       fromFavourite: false
    //     }
    //   }
    // );
    this.bookingFromFavourite = true;
    const newBooking = { ...this.newBookingObject };
    this.newBookingObject = {} as IBookingCreate;
    newBooking.targetUserId = this.favouriteUserId;
    // newBooking.favourite = favourite;
    newBooking.favourite = favourite;
    newBooking.originStop = { ...favourite.inStop, id: favouriteStopId(favourite.inStop) };
    newBooking.destinationStop = { ...favourite.outStop, id: favouriteStopId(favourite.outStop, false) };
    // this.newBookingObject.destinationStops = [];
    // newBooking.townId = newBooking.user.town?.id!;
    // newBooking.time = moment().format('HH:mm');
    this.newBookingObject = newBooking;
    this.changeDetectorRef.detectChanges();
    this.viewFavourites.toggle();
  }

  async rebook(booking: IBooking) {
    this.rebookBooking = true;

    let queryParams: any = {
      'bookingId': booking.id
    }
    if (booking.cancelled) queryParams = {
      ...queryParams,
      'cancelled': booking.cancelled
    }
    
    this.router.navigate(
      ['/bookings/new'],
      {
        queryParams: queryParams
      }
    );
  }

  async updateTicketing() {
    const { id, paidDateTime, validatedDateTime } = this.bookingSelected as IBookingDetails;
    const response: any = await this.bookingsService.updateTicketStatus(id!, !!paidDateTime, !!validatedDateTime);
    this.bookingSelected.paidDateTime = response.paidDateTime;
    this.bookingSelected.validatedDateTime = response.validatedDateTime;
    this.notificationService.image = this.images.booking.ticket.ticket;
    this.notificationService.title = this.literalService.get(
      `bookings.actions.ticketingStatus.notification.title`,
      true,
    );
    const statusKey = `bookings.actions.ticketingStatus.notification.${
      this.bookingSelected.paidDateTime ? 'paidText' : 'notPaidText'
    }And${
      this.bookingSelected.validatedDateTime ? 'ValidatedText' : 'NotValidatedText'
    }`;
    const ticketResultStatus = this.literalService.get(statusKey);
    this.notificationService.message = this.literalService.get(
      `bookings.actions.ticketingStatus.notification.ticketMarked`,
      true,
    ) + ticketResultStatus;
    this.notificationService.show(NotificationTypes.SUCCESS);
  }

  resendMail(event: any) {
    this.bookingsService.resendMail(this.bookingSelected.id, event.sendRelated).then(() => {
      this.utilsService.showNotification(images.notifications.check, 'bookings.actions.ticketingStatus.resend.notification', NotificationTypes.SUCCESS);
    });
  }

  closeExceedingKm() {
    this.newBookingObject = {} as IBookingCreate;
    this.newBookingObject.destinationStops = [];
    this.newBookingObject.stops = [];
    this.newBookingObject.date = moment().format('YYYY-MM-DD');
    this.newBookingObject.time = moment().format('HH:mm');
    this.closeExceedingKmHandler = true;
  }

  updateSelectableBookings(action?: any) {
    if (this.bulkAction !== action) this.bulkAction = action;
    switch (this.bulkAction) {
      case IBulkActionType.EDIT:
        this.clearBookingsInterval();
        this.bookings.value = this.bookings.value.map((booking) => ({
          ...booking,
          selectable: booking.cancellable && booking.editable && booking.tripType !== ExpeditionType.HybridDoor2Door && booking.tripType !== ExpeditionType.DynamicDoor2Door
        }));
        break;
      case IBulkActionType.DELETE:
        this.clearBookingsInterval();
        this.bookings.value = this.bookings.value.map((booking) => ({
          ...booking,
          selectable: booking.cancellable
        }));
        break;
      default:
        this.resetMultipleSelection();
        this.initBookingsInterval();
        break;
    }
  }

  async onBulkAction() {
    this.bulkBookingsSelected = this.bookings.value.filter((booking) => booking.selected);
    if (this.bulkBookingsSelected.length > 0) {
      switch (this.bulkAction) {
        case IBulkActionType.EDIT:
          const routeValues = await getServiceInfoRoutes(this.serviceInfoService, this.bulkBookingsSelected[0] as IBookingDetails);
          const firstRouteId = (this.bulkBookingsSelected[0] as any).routeId;
          const allSameRoute = firstRouteId && this.bulkBookingsSelected.every((b: any) => b.routeId === firstRouteId);
          const preselectedRouteId = allSameRoute ? firstRouteId : undefined;
          this.routesElement = {
            img: images.services.route,
            title: 'services.routes.routeTitle',
            color: true,
            value: preselectedRouteId,
            edit: {
              inputType: InputType.SELECT_SEARCH,
              placeholder: this.literalService.get('bookings.actions.reassignBookings.inputPlaceholder', true),
              values: routeValues,
            },
          };
          this.availabilitiesElement = null;
          this.bulkText = this.literalService.get('bookings.actions.reassignBookings.modalText', true, { num: this.bulkBookingsSelected.length.toString()});
          this.reassignAvailabilityModal = new Modal(document.getElementById('reassignAvailability'), {
            closable: false,
            onHide: () => {
              this.reassignAvailabilityShowed = false;
              this.routesElement = null;
              this.availabilitiesElement = null;
            },
            onShow: () => (this.reassignAvailabilityShowed = true),
          });
          this.reassignAvailabilityModal.show();
          if (preselectedRouteId) {
            this.getRouteAvailabilities({ id: preselectedRouteId });
          }
          break;
        case IBulkActionType.DELETE:
          this.bulkText = this.literalService.get('bookings.actions.deleteBooking.bulkText', true, { num: this.bulkBookingsSelected.length.toString()});
          this.bulkDeleteModal = new Modal(document.getElementById('bulkDeleteBookings'), {
            closable: false,
            onHide: () => (this.bulkDeleteShowed = false),
            onShow: () => (this.bulkDeleteShowed = true),
          });
          this.bulkDeleteModal.show();
          break;
      }
    }
  }

  selectAll(event: Event) {
    if (this.isAllSelectionDisabled()) {
      event.preventDefault();
      this.utilsService.showNotification(images.notifications.info, 'bookings.actions.selectDisabled', NotificationTypes.INFO, 'title', this.bulkAction === IBulkActionType.EDIT ? 'differentService' : 'text');
    } else {
      this.bookings.value = this.bookings.value.map((booking) => ({...booking, selected: booking.selectable && (<HTMLInputElement>event.target).checked}));
      if ((<HTMLInputElement>event.target).checked) this.allBookingsSelected = true;
      else {
        this.allBookingsSelected = false;
        this.updateSelectableBookings(this.bulkAction);
      }
    }
  }

  onSelectionChange(bookingId: number) {
    if (this.bulkAction !== '') {
      const index = this.bookings.value.findIndex(booking => booking.id === bookingId);
      if (this.bookings.value[index].selectable) {
        this.bookings.value[index].selected = !this.bookings.value[index].selected;
        if (this.bulkAction === IBulkActionType.EDIT) {
          if (this.bookings.value.some(booking => booking.selected)) {
            const serviceId = this.bookings.value[index].service.id;
            this.bookings.value = this.bookings.value.map((booking) => {
              if (booking.service.id !== serviceId) return {...booking, selectable: false};
              return booking;
            });
            this.allBookingsSelected = this.bookings.value.filter((booking) => booking.service.id === serviceId).every((booking) => booking.selected);
          } else {
            this.updateSelectableBookings(this.bulkAction);
            this.allBookingsSelected = false;
          }
        } else {
          this.updateSelectableBookings(this.bulkAction);
          if (this.bookings.value.every((booking) => booking.selected)) this.allBookingsSelected = true;
          else this.allBookingsSelected = false;
        }

      } else {
        const booking = this.bookings.value.find(booking => booking.id === bookingId);
        this.utilsService.showNotification(images.notifications.info, 'bookings.actions.selectDisabled', NotificationTypes.INFO, 'title', (!booking?.cancellable || !booking.editable || booking.tripType === ExpeditionType.HybridDoor2Door || booking.tripType === ExpeditionType.DynamicDoor2Door) ? 'text' : 'differentService');
      }
    }
  }

  async handleChangePaginationSize(newSize: any) {
    const parsedSize = Number(newSize);
    const size = (!parsedSize || parsedSize <= 0) ? APP.DEFAULT_PAGE_SIZE : parsedSize;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { size: size === APP.DEFAULT_PAGE_SIZE ? null : size, page: null },
      queryParamsHandling: 'merge',
    });
  }

  isAllSelectionDisabled() {
    if (this.bulkAction == IBulkActionType.DELETE) {
      return this.bookings.value.some(booking => !booking.cancellable);
    } else {
      if (this.bookings.value.every((booking) => !booking.editable || booking.tripType === ExpeditionType.HybridDoor2Door || booking.tripType === ExpeditionType.DynamicDoor2Door || !booking.selected)) return true;
      return false;
    }
  }

  resetMultipleSelection() {
    this.bookings.value = this.bookings.value.map((booking) => ({
      ...booking,
      selected: false,
      selectable: true
    }));
    this.allBookingsSelected = false;
  }

  async deleteMultipleBookings(data: any) {
    const bookingsToDelete = this.bookings.value.filter(booking => booking.selected).map(booking => ({
      id: booking.id,
      comment: data.reason,
      sendNotification: data.sendNotification,
      refund: data.refund,
      fullRefund: data.fullRefund,
      related: data.related
    }));
    if (bookingsToDelete.length > 0) {
      this.loadingAction = true;
      await this.bookingsService.deleteMultipleBooking(bookingsToDelete).then(async () => {
        this.bulkDeleteModal.hide();
        this.utilsService.showNotification(images.notifications.check, 'bookings.actions.deleteBooking.successBulk', NotificationTypes.SUCCESS);
        this.searching = true;
        await this.getBookings();
        this.searching = false;
        this.resetMultipleSelection();
      }, () => {
        this.notificationService.image = images.notification.error;
        this.notificationService.title = this.literalService.get(`errorOccurred`, true);
        this.notificationService.message = this.literalService.get(`0`, true);
        this.notificationService.show(NotificationTypes.DANGER);
      }).finally(() => {
        this.loadingAction = false;
      });
    }
  }

  async getRouteAvailabilities(data: any) {
    this.loadingAvailabilities = true;
    await this.routeService.getAvailabilities(data.id, 0, 100).then((res) => {
      let availabilities: any = []
      res.content.map((availability: IServiceAvailability) => {
        availabilities.push(
          {
            id: availability.id,
            value: availability.id,
            label: `${formatDate(availability.startDateTime, this.literalService)} (${availability.driver!.name} - ${availability.vehicle!.name})`
          }
        );
      });
      const firstAvailabilityId = this.bulkBookingsSelected[0]?.availability?.id;
      const allSameAvailability = firstAvailabilityId && this.bulkBookingsSelected.every((b: any) => b.availability?.id === firstAvailabilityId);
      this.availabilitiesElement = {
        img: images.booking.availability,
        title: 'bookings.actions.reassignBookings.inputTitle',
        color: true,
        value: allSameAvailability ? firstAvailabilityId : undefined,
        edit: {
          inputType: InputType.SELECT_SEARCH,
          placeholder: this.literalService.get('bookings.actions.reassignBookings.inputPlaceholder', true),
          values: availabilities
        },
      };
    });
    this.loadingAvailabilities = false;
  }

  async reassignMultipleBookings(data: any) {
    const selectedBookingsIds = this.bookings.value.filter(booking => booking.selected).map(booking => (booking.id!));
    if (selectedBookingsIds.length > 0) {
      this.loadingAction = true;
      this.loadingPercentage = 0;
      this.phaseStatus = PhaseStatus.IN_PROGRESS;
      try {
        const resp: any = await this.bookingsService.reassignAvailability(selectedBookingsIds, data.newAvailability.id, data.sendNotification, data.recomputePrice);
        const ephemeralToken = await this.authService.getEphemeralToken() as string;
        this.webSocketService.connect(resp, ephemeralToken);
        this.webSocketService.getMessages().subscribe({
          next: async (message: any) => {
            this.loadingPercentage = message.total_percentage;
            if (this.webSocketService.isIntermediatePhaseCompletion(message)) return;
            this.phaseStatus = message.phase_status;
            switch(this.phaseStatus) {
              case PhaseStatus.COMPLETED:
                this.reassignAvailabilityModal.hide();
                this.utilsService.showNotification(images.notifications.check, 'bookings.actions.reassignBookings.success', NotificationTypes.SUCCESS);
                this.loadingAction = false;
                this.searching = true;
                await this.getBookings();
                this.searching = false;
                break;
              case PhaseStatus.FAILED:
                const error = this.utilsService.isJSON(message.progress_entity_data) ? JSON.parse(message.progress_entity_data) : undefined;
                this.utilsService.showNotification(images.notifications.warning, `${error.error_code}_ERROR`, NotificationTypes.DANGER);
                this.loadingAction = false;
                break;
            }
          },
          error: (err: any) => {
            this.loadingAction = false;
            this.utilsService.showNotification(images.notifications.warning, 'bookings.actions.reassignBookings.error', NotificationTypes.DANGER);
          }
        });
      } catch(e: any) {
        this.loadingAction = false;
      }
    }
  }

  getDisabledCheckboxTitle() {
    let key = '';
    switch(this.bulkAction) {
      case IBulkActionType.EDIT:
        if (this.bookings.value.some((booking) => booking.selected)) key = `bookings.actions.reassignBookings.disabled.differentService`;
        else key =`bookings.actions.reassignBookings.disabled.default`;
        break;
      case IBulkActionType.DELETE:
        key = `bookings.actions.deleteBooking.disabled.default`;
        break;
    }
    return this.literalService.get(key, true);
  }
  
  goToNewFavourite() {
    this.bookingFromFavourite = true;
    const newBooking = { ...this.newBookingObject };
    this.newBookingObject = {} as IBookingCreate;
    newBooking.favourite = undefined;
    newBooking.townId = newBooking.townId ?? newBooking.user.town?.id!;
    newBooking.time = newBooking.time ?? moment().format('HH:mm');
    this.newBookingObject = newBooking;
    this.changeDetectorRef.detectChanges();
    this.viewFavourites.toggle();
  }

  onShowChangeSeatsModal(event: any) {
    if (this.newBooking) {
      this.newBookingObject = event.newBooking;
      this.seatsModalEditable = event.editable;
    } else {
      this.seatsModalEditable = true;
    }
    this.changeSeats = new Modal(document.getElementById('changeSeats'), {
      closable: false,
      onHide: () => { this.changeSeatsShowed = false; },
      onShow: () => {
        this.bookingCopy = {};
        this.bookingCopy.bookingSeats = [...this.newBookingObject.destinationStops];
        this.bookingCopy.destination = this.newBookingObject.destinationStops[0].exitStop;
        this.bookingCopy.userId = this.newBookingObject.user.id;
        this.changeSeatsShowed = true;
      },
    });
    this.changeSeats.toggle();
  }

  onSeatsSubmit(event: any): void {
    const submitBooking = event.booking as IBookingDetails;
    this.newBookingObject = {
      ...this.newBookingObject,
      destinationStops: [...submitBooking.bookingSeats]
    };
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    this.bookingsResizeObserver?.disconnect();
    this.closeModals();
    this.queryParamsSub?.unsubscribe();
    this.routeParamsSub?.unsubscribe();
    this.dataSub?.unsubscribe();
  }
}
